import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { type FC, type ReactNode } from "react";
import { useDialog } from "../../../../../../utils/hooks/use-dialog";
import type { ChannelName } from "../../../../../channels/types";
import { prettyChannelName } from "../../../../../channels/utils";

type Props = {
  channelName: ChannelName;
  clickableText: string;
  suffixText: string;
  children: ReactNode;
};

export const PreviewMissingButton: FC<Props> = ({
  clickableText,
  suffixText,
  channelName,
  children,
}) => {
  const dialog = useDialog();

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        data-analytics-id="people-missing-channel-button"
      >
        <Link
          component="button"
          type="button"
          color="primary"
          underline="hover"
          variant="caption"
          onClick={() => dialog.handleOpen("missing")}
          sx={{ fontWeight: "400" }}
        >
          {clickableText}
        </Link>
        <Typography variant="caption">{suffixText}</Typography>
      </Stack>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        <DialogTitle>People without {prettyChannelName(channelName)}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="body2">{`These people don't have ${prettyChannelName(channelName)} enabled in their record`}</Typography>
            {children}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={dialog.handleClose} data-analytics-id="people-in-segment-close-button">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
